export const getHost = () => {
  const origin = window.location.origin;
  const enggHost = "https://gc-distribution-engg-be.bstkinternal.net";
  const prodHost = "https://gc-distribution-be-prod.bstkinternal.net";
  if (origin.includes("promotions-engg")) return enggHost;
  return prodHost;
};
